import {
	blackColor,
	$colorNeutrals100,
	whiteColor,
	formElementColors,
	support1Color,
	grayColor,
} from 'assets/jss/material-dashboard-pro-react';

const notificationPanelStyle = (theme) => ({
	buttonGroup: {
		display: 'flex',
		gap: '0.5rem',
		'& button span': {
			marginBottom: '0',
			fontSize: theme.fontSize(12),
		},
		'& button svg': {
			transform: theme.direction === 'rtl' ? 'rotate(180deg)' : 'none',
		},
	},
	drawer: {
		width: '100%',
		[theme.breakpoints.up('sm')]: {
			width: '50%',
			maxWidth: '430px',
		},
	},
	drawerPaper: {
		width: '100%',
		[theme.breakpoints.up('sm')]: {
			width: '50%',
			maxWidth: '430px',
		},
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'column-reverse',
		alignItems: 'flex-start',
		padding: theme.spacing(3),
		'& h6': {
			textTransform: 'capitalize',
			fontSize: theme.fontSize(32),
			fontFamily: theme.fontFamily.albert.bold + '!important',
			[theme.breakpoints.up('md')]: {
				fontSize: theme.fontSize(20),
			},
		},
	},
	filters: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		margin: theme.spacing(0, 3),
		borderBottom: `1px solid ${blackColor}`,
		'& button span': {
			fontFamily: theme.fontFamily.albert.bold,
			textTransform: 'capitalize',
		},
	},
	list: {
		paddingTop: 0,
	},
	singleWrapper: {
		padding: theme.spacing(2, 3),
		display: 'flex',
		// '&:last-of-type': {
		// 	borderBottom: 'none',
		// },
	},

	itemText: {
		marginLeft: theme.spacing(2),
		position: 'relative',
		'& span': {
			fontSize: theme.fontSize(14),
			marginBottom: theme.spacing(1),
			fontFamily: theme.fontFamily.albert.bold,
		},
		'& p': {
			fontSize: theme.fontSize(12),
			fontFamily: theme.fontFamily.albert.regular,
			paddingRight: theme.spacing(2),
		},
		'& $buttonGroup span': {
			marginBottom: '0',
		},
	},
	time: {
		display: 'block',
		fontFamily: theme.fontFamily.albert.regular + '!important',
		fontSize: theme.fontSize(12) + '!important',
		paddingTop: '2px',
	},
	listItem: ({ read }) => ({
		borderBottom: `1px solid ${$colorNeutrals100}`,
		backgroundColor: read ? formElementColors.bg : whiteColor,
	}),
	button: {
		marginRight: theme.spacing(1),
	},
	date: {
		margin: theme.spacing(2),
		fontFamily: theme.fontFamily.albert.bold,
	},
	iconWrapper: { position: 'relative' },
	unReadIndecator: {
		position: 'absolute',
		background: support1Color[0],
		height: '10px',
		width: '10px',
		borderRadius: '100%',
		top: '50%',
		right: 0,
		transform: 'translate(-50%)',
	},
	iconCircle: {
		background: grayColor[1],
		borderRadius: '100%',
		display: 'flex',
		alignItems: 'center',
		width: '56px',
		height: '56px',
		justifyContent: 'center',
	},
	emptyMessage: {
		padding: '16px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		textAlign: 'center',
		height: '100%',
	},
	itemTextContainer: {
		display: 'flex',
		justifyContent: 'space-between',
	},
});

export default notificationPanelStyle;
